export default {'version' : '1.2-7-g3531db4'};
